import {put, takeEvery} from "@redux-saga/core/effects";
import {handleNotificationAlertCatch, handleNotificationAlertTrySelect} from "common/method/handleNotificationAlert";
import AxiosCustom from "../../../common/components/apiConfig";

export const actionTypes = {
    selectMemberCreditPlan: "[selectMemberCreditPlan] Action",
    selectMemberCreditPlanLoad: "[selectMemberCreditPlanLoad] Action",
    selectMemberCreditPlanAsync: "[selectMemberCreditPlanAsync] Action",
};

const initialState = {
    data: [],
    loading: false,
};

export const select_member_credit_plan_reducer = (
    state = initialState,
    {type, payload},
) => {
    switch (type) {
        case actionTypes.selectMemberCreditPlan:
            return {
                ...state,
                data: payload?.data?.results ? payload?.data?.results : [],
            };

        case actionTypes.selectMemberCreditPlanLoad:
            return {
                ...state,
                loading: payload,
            };
        default:
            return state;
    }
};

function* handleWorker({payload}) {
    yield put({type: actionTypes.selectMemberCreditPlanLoad, payload: true});
    let config = {
        url: "select_request",
    };

    let data = {
        table: "credit",
        method_type: "select_member_credit_plans",
        data: {},
        sort_by: {},
        size: "50",
        from: "0",
    };

    try {
        let res = yield AxiosCustom(config, data);
        const isOk = handleNotificationAlertTrySelect(res)
        if (isOk) {
            yield put({
                type: actionTypes.selectMemberCreditPlan,
                payload: res.data.response,
            });
        }
    } catch {
        handleNotificationAlertCatch();
    } finally {
        yield put({type: actionTypes.selectMemberCreditPlanLoad, payload: false});
    }
}

export function* selectMemberCreditPlan() {
    yield takeEvery(actionTypes.selectMemberCreditPlanAsync, handleWorker);
}
